{
  "Clear search": "נקה חיפוש"
}
